<div
    *ngIf="user_"
    class="agpr-userProfile-container"
    [agprLoading]="loading"
    [agprGlobalLoading]="true"
>

    @if(user_.id && !user_.isActive) {
        <agpr-message [severity]="messageSeverityEnum.info">
            {{ 'UMT.header.inactiveMsg' | localize }}
        </agpr-message>
    }

    <agpr-panel
        header="UMT.userDetails"
        headingLevel="3"
        [marginTop]="0"
    >
        <div class="agpr-userProfile-userType">
            <agpr-radio
                id="umt_user_userType_client"
                label="UMT.userType.client"
                hiddenLabel="UMT.userType.client"
                [(ngModel)]="user_.internal"
                [value]="false"
                [disabled]="isReadOnly || !internalPermission"
                (ngModelChange)="userTypeChange()"
            ></agpr-radio>
            <agpr-radio
                id="umt_user_userType_internal"
                label="UMT.userType.internal"
                hiddenLabel="UMT.userType.internal"
                [(ngModel)]="user_.internal"
                [value]="true"
                [disabled]="isReadOnly || !internalPermission"
                (ngModelChange)="userTypeChange()"
            ></agpr-radio>
        </div>
        <div class="agpr-userProfile-gridContainer">

            <agpr-text-input
                id="umt_user_firstname"
                class="agpr-userProfile-gridItem"
                [required]="true"
                label="Discover.contactEditor.fields.firstName.label"
                [(ngModel)]="user_.firstName"
                [disabled]="!user_.isActive || isReadOnly || !user_.neptuneOnly"
                [initialFocus]="true"
            >
            </agpr-text-input>

            <agpr-text-input
                id="umt_user_lastname"
                class="agpr-userProfile-gridItem"
                [required]="true"
                label="Discover.contactEditor.fields.lastName.label"
                [disabled]="!user_.isActive || isReadOnly || !user_.neptuneOnly"
                [(ngModel)]="user_.lastName"
            >
            </agpr-text-input>
            <agpr-email-text-input
                id="umt_user_username"
                class="agpr-userProfile-gridItem"
                [required]="true"
                label="UMT.profile.username"
                [disabled]="!!user_.id || isReadOnly || !user_.neptuneOnly"
                [(ngModel)]="user_.username"
            >
            </agpr-email-text-input>
            <agpr-email-text-input
                id="umt_user_email"
                class="agpr-userProfile-gridItem"
                [required]="true"
                label="UMT.profile.email"
                [disabled]="!user_.isActive || isReadOnly || !user_.neptuneOnly"
                [(ngModel)]="user_.email"
            >
            </agpr-email-text-input>
            <agpr-dropdown
                *ngIf="primaryAccount?.neptuneOnly || !user_.id"
                id="umt_user_maxSession"
                class="agpr-userProfile-gridItem"
                label="UMT.profile.maxSessions"
                infoCircleTooltip="UMT.profile.maxSessions.tooltip"
                [disabled]="!user_.isActive || isReadOnly"
                [options]="maxSessionOptions"
                [allowNull]="true"
                [bindToValue]="true"
                [(ngModel)]="user_.maxSessions"
            >
            </agpr-dropdown>
        </div>
    </agpr-panel>
    <agpr-panel
        header="AMT.LHP.heading"
        headingLevel="3"
        [marginTop]="20"
    >
        <agpr-autocomplete
            [disabled]="isReadOnly"
            [(ngModel)]="accounts"
            [required]="true"
            (itemSelected)="addAccount($event)"
            labelLookupKey="id"
            [suggestionsFetcher]="accountManagementService.searchNeptuneOnlyAccounts.bind(accountManagementService)"
            labelField="name"
            placeholder="UMT.accounts.autocomplete.placeholder"
            [multiSelection]="true"
            selectedItemsHideKey="id"
        ></agpr-autocomplete>
        <div
            *ngFor="let account of accounts"
            class="agpr-userProfile-accounts"
        >
            <span>
                {{account.name}}
                <span
                    [ngClass]="{'agpr-userProfile-accounts-neptuneOnly': account?.neptuneOnly}"
                    [agprTooltip]="account?.neptuneOnly ? 'AMT.header.neptuneOnly.tooltip' : null"
                >
                    ({{account.id}})
                </span>
            </span>
            <span
                *ngIf="account.id === user_.primaryAccountId"
                class="agpr-userProfile-accounts-primary"
            >
                PRIMARY
            </span>
            <span
                *ngIf="!isReadOnly"
                class="agpr-userProfile-accounts-contextMenu"
            >
                <!-- we can only set the primary if there is already a primary account with credentials on it -->
                <!-- basically you can't do it until the user went through the registration process and created -->
                <!-- the first credentials.  After that we can move the credentials around to a new primary -->
                <agpr-button
                    *ngIf="(account.id !== user_.primaryAccountId) &&
                        !!user_.primaryAccountId &&
                        account.neptuneOnly &&
                        user_.neptuneOnly &&
                        account.active &&
                        !account.isExpiryDatePast"
                    label="Make Primary"
                    (click)="makePrimary(account)"
                    [style]="buttonTypes.link"
                    class="agpr-userProfile-accounts-makePrimary"
                >
                </agpr-button>
                <agpr-button
                    *ngIf="account.id !== user_.primaryAccountId &&
                        accounts.length > 1 &&
                        account.neptuneOnly"
                    icon="fa-regular fa-duotone fa-trash-can"
                    (click)="removeAccount(account.id)"
                    [style]="buttonTypes.icon"
                    tooltip="Delete"
                    class="agpr-userProfile-accounts-iconButton"
                >
                </agpr-button>
                <agpr-button
                    *ngIf="account.active &&
                        account.neptuneOnly &&
                        ghostInPermission &&
                        user_.isActive &&
                        user_.neptuneOnly"
                    icon="fa-regular fa-duotone fa-ghost"
                    (click)="ghostIn(account.id)"
                    [style]="buttonTypes.icon"
                    tooltip="Ghost In"
                    class="agpr-userProfile-accounts-iconButton"
                >
                </agpr-button>
            </span>
        </div>
    </agpr-panel>

    <agpr-panel
        header="UMT.profile.permissions"
        class="agpr-userProfile-permissions"
        headingLevel="3"
        [marginTop]="20"
    >
        <ul
            [attr.aria-label]="'UMT.profile.permissions' | localize"
        >
            @for (userPermission of allUserPermissions; track userPermission.enum) {
                @let settable = user_.internal
                    || !userPermission.isInternalUserPermission
                    || userPermission.enum === userPermissions.accountGhostIn && accountsPartnerResellerId !== null;
                <li class="agpr-userProfile-permissions-listItem">
                    <agpr-checkbox
                        [id]="'userProfilePermissions_' + userPermission.enum"
                        [label]="userPermission.displayString"
                        [value]="userPermission.enum"
                        [(ngModel)]="user_.permissions"
                        [infoCircleTooltip]="userPermission.enum === userPermissions.apiKeyManagement
                            ? userPermission.tooltip
                            : settable
                                ? userPermission.tooltip
                                : 'Available for Internal users only.'"
                        [disabled]="isReadOnly || !settable || (userPermission.enum === userPermissions.apiKeyManagement && !hasMediaMonitoringApi)"
                        (onChange)="onPermissionChanged(userPermission.enum, $event)"
                    >
                    </agpr-checkbox>
                </li>
            }
        </ul>
    </agpr-panel>
    <agpr-panel
        header="Multi-Factor Authentication"
        class="agpr-userProfile-mfa"
        headingLevel="3"
        [marginTop]="20"
    >
        <div class="agpr-userProfile-mfa-resetButton">
            <agpr-button
                *ngIf="mfaMethods.length > 0"
                label="Mfa.umt.reset"
                (click)="resetMfa()"
                [style]="buttonTypes.tertiary"
            ></agpr-button>
        </div>
        <agpr-mfa-management></agpr-mfa-management>
    </agpr-panel>

    <agpr-panel
        header="UMT.profile.MediaDatabaseApi"
        class="agpr-userProfile-mediaDatabaseApi"
        headingLevel="3"
        [marginTop]="20"
    >
        <agpr-autocomplete
            id="userProfile_MediaDatabaseApi_accounts"
            [disabled]="isReadOnly"
            class="agpr-userProfile-addUser-autocomplete"
            placeholder="UMT.profile.MediaDatabaseApi.autocomplete.placeholder"
            labelField="name"
            label="UMT.profile.MediaDatabaseApi.accounts"
            ariaLabel="UMT.profile.MediaDatabaseApi.accounts"
            labelLookupKey="id"
            (itemSelected)="addAccount($event)"
            [suggestionsFetcher]="accountManagementService.searchMediaDbApiAccounts.bind(accountManagementService)"
        ></agpr-autocomplete>
        @for (mediaDatabaseUserAccount of mediaDatabaseUserAccounts; track mediaDatabaseUserAccount) {
            <div class="agpr-userProfile-mediaDatabaseApiCard">
                <div class="agpr-userProfile-mediaDatabaseApiCard-header">
                    {{ mediaDatabaseUserAccount.accountName }}
                </div>

                <!-- account Id -->
                <div class="agpr-userProfile-mediaDatabaseApiCard-titleContainer">
                    <span class="agpr-userProfile-mediaDatabaseApiCard-title">
                        {{ 'UMT.profile.MediaDatabaseApi.accountId' | localize}}
                    </span>
                </div>
                <div class="agpr-userProfile-mediaDatabaseApiCard-content">
                    {{ mediaDatabaseUserAccount?.accountId }}
                </div>

                <!-- partner reseller -->
                <div class="agpr-userProfile-mediaDatabaseApiCard-titleContainer">
                    <span class="agpr-userProfile-mediaDatabaseApiCard-title">
                        {{ 'UMT.profile.MediaDatabaseApi.partnerReseller' | localize}}
                    </span>
                </div>
                <div class="agpr-userProfile-mediaDatabaseApiCard-content">
                    {{ mediaDatabaseUserAccount?.partnerReseller }}
                </div>
                @if (mediaDatabaseUserAccount.apiKey) {
                    <div class="agpr-userProfile-mediaDatabaseApiCard-titleContainer">
                        <span class="agpr-userProfile-mediaDatabaseApiCard-title">
                            {{ 'UMT.profile.MediaDatabaseApi.apiKey' | localize}}
                        </span>
                        <agpr-button
                            class="agpr-userProfile-copyIcon"
                            [style]="buttonTypes.icon"
                            icon="fa-kit-duotone fa-agpr-copy"
                            tooltip="UMT.profile.MediaDatabaseApi.apiKey.copy"
                            tooltipPosition="top"
                            (click)="copy(mediaDatabaseUserAccount.apiKey)"
                        ></agpr-button>
                    </div>
                    <div class="agpr-userProfile-mediaDatabaseApiCard-content">
                        {{ mediaDatabaseUserAccount.apiKey }}
                    </div>
                }

                @if (mediaDatabaseUserAccount.accessToken) {
                    <div class="agpr-userProfile-mediaDatabaseApiCard-titleContainer">
                        <span class="agpr-userProfile-mediaDatabaseApiCard-title">
                            {{ 'UMT.profile.MediaDatabaseApi.accessToken' | localize}}
                        </span>
                        <agpr-button
                            class="agpr-userProfile-copyIcon"
                            [style]="buttonTypes.icon"
                            icon="fa-kit-duotone fa-agpr-copy"
                            tooltip="UMT.profile.MediaDatabaseApi.accessToken.copy"
                            tooltipPosition="top"
                            (click)="copy(mediaDatabaseUserAccount.accessToken)"
                        ></agpr-button>
                    </div>
                    <div class="agpr-userProfile-mediaDatabaseApiCard-content">
                        {{ mediaDatabaseUserAccount.accessToken }}
                    </div>
                }

                @if (mediaDatabaseUserAccount.clientId) {
                    <div class="agpr-userProfile-mediaDatabaseApiCard-titleContainer">
                        <span class="agpr-userProfile-mediaDatabaseApiCard-title">
                            {{ 'UMT.profile.MediaDatabaseApi.clientId' | localize}}
                        </span>
                        <agpr-button
                            class="agpr-userProfile-copyIcon"
                            [style]="buttonTypes.icon"
                            icon="fa-kit-duotone fa-agpr-copy"
                            tooltip="UMT.profile.MediaDatabaseApi.clientId.copy"
                            tooltipPosition="top"
                            (click)="copy(mediaDatabaseUserAccount.clientId)"
                        ></agpr-button>
                    </div>
                    <div class="agpr-userProfile-mediaDatabaseApiCard-content">
                        {{ mediaDatabaseUserAccount.clientId }}
                    </div>
                }

                @if (mediaDatabaseUserAccount.userClientId) {
                    <div class="agpr-userProfile-mediaDatabaseApiCard-titleContainer">
                        <span class="agpr-userProfile-mediaDatabaseApiCard-title">
                            {{ 'UMT.profile.MediaDatabaseApi.userClientId' | localize}}
                        </span>
                        <agpr-button
                            class="agpr-userProfile-copyIcon"
                            [style]="buttonTypes.icon"
                            icon="fa-kit-duotone fa-agpr-copy"
                            tooltip="UMT.profile.MediaDatabaseApi.userClientId.copy"
                            tooltipPosition="top"
                            (click)="copy(mediaDatabaseUserAccount.userClientId)"
                        ></agpr-button>
                    </div>
                    <div class="agpr-userProfile-mediaDatabaseApiCard-content">
                        {{ mediaDatabaseUserAccount.userClientId }}
                    </div>
                }

                @if(mediaDatabaseUserAccount.selectedPreferredLanguage) {
                    <div class="agpr-userProfile-mediaDatabaseApiCard-titleContainer">
                        <span class="agpr-userProfile-mediaDatabaseApiCard-title">
                            {{ 'UMT.profile.MediaDatabaseApi.preferredLanguage' | localize}}
                        </span>
                    </div>
                    <div class="agpr-userProfile-mediaDatabaseApiCard-content">
                        <agpr-dropdown
                            [id]="'userProfile_MediaDatabaseApi_accounts'"
                            [options]="preferredLanguageOptions"
                            [(ngModel)]="mediaDatabaseUserAccount.selectedPreferredLanguage"
                            (ngModelChange)="preferredLanguageChanged(mediaDatabaseUserAccount, $event.value)"
                        ></agpr-dropdown>
                    </div>
                }
                <div class="agpr-userProfile-mediaDatabaseApiCard-contextMenu">
                    <agpr-button
                        [id]="'userProfilePermissions_' + mediaDatabaseUserAccount.accountId + '_delete'"
                        [style]="buttonTypes.iconFilled"
                        [icon]="'fa-regular fa-duotone fa-trash-can'"
                        class="agpr-userProfile-mediaDatabaseApiCard-contextMenu-button"
                        tooltip="UMT.profile.MediaDatabaseApi.card.delete"
                        tooltipPosition="top"
                        (click)="removeAccount(mediaDatabaseUserAccount.accountId)"
                    ></agpr-button>
                </div>
            </div>
        }
    </agpr-panel>
</div>

<ng-template #actionButton>
    @if(user_.isActive) {
        <agpr-split-button
            label="UMT.button.actions"
            [options]="actionButtons"
            panelPositionY="top"
            panelPositionX="right"
        ></agpr-split-button>
    } @else {
        <agpr-button
            [style]="buttonTypes.primaryB"
            label="UMT.header.activateUser"
            [disabled]="actionButtons[0].disabled"
            (click)="actionButtons[0].command()"
        ></agpr-button>
    }
</ng-template>